module.exports = __webpack_public_path__ + "img/file-earmark-check.12677d9b.svg";